import { msalInstance } from "@/index";
import { IdTokenClaims } from "@/types/auth.types";
import { DynamicsContact } from "@/types/dynamics.types";

export type UserRole = "BusinessAdmin" | "BusinessUser" | "Personal";

export interface UserRoles {
  roles: UserRole[];
  isBusinessAdmin: boolean;
  isBusinessUser: boolean;
  isPersonalUser: boolean;
  jobTitle?: string;
}

interface AuthorizationHook {
  getRoles: () => UserRoles;
  hasCompany: (dynamicsContact?: DynamicsContact) => boolean;
}

function useAuthorization(): AuthorizationHook {
  const account = msalInstance.getActiveAccount();
  const idTokenClaims = account?.idTokenClaims as IdTokenClaims | undefined;

  function getRoles(): UserRoles {
    const jobTitle = idTokenClaims?.JobTitle;
    let roles: UserRole[] = [];

    // Map JobTitle to roles
    if (jobTitle === "BUSINESSADMIN") {
      roles = ["BusinessAdmin"];
    } else if (jobTitle === "BUSINESSUSER") {
      roles = ["BusinessUser"];
    } else if (jobTitle === "CITIZEN") {
      roles = ["Personal"];
    }

    return {
      roles,
      isBusinessAdmin: roles.includes("BusinessAdmin"),
      isBusinessUser: roles.includes("BusinessUser"),
      isPersonalUser: roles.includes("Personal"),
      jobTitle,
    };
  }

  function hasCompany(dynamicsContact?: DynamicsContact): boolean {
    return Boolean(dynamicsContact?.organizations?.length);
  }

  return {
    getRoles,
    hasCompany,
  };
}

export { useAuthorization };
